import "./App.css";
import Header from "./layouts/Header/Header";
import YandexMap from "./layouts/YandexMap/YandexMap";

function App() {
  return (
    <div className="App">
      <Header />
      <YandexMap />
    </div>
  );
}

export default App;
